import { axios } from "@/lib/axios";
import { AxiosResponse } from "axios";
import { TReportingBodyRequest } from "../types/profile.types";

export const  apiUpdateDashboard = ( data:TReportingBodyRequest ):Promise<AxiosResponse<any, any>> => {
    return axios.post('/reporting',data);
}

export const  apiLineChartResilitation = ( data:any ):Promise<AxiosResponse<any, any>> => {
    return axios.post('/graphe-resilie',data);
}

export const  apiLineChartAbonnement = ( data:any ):Promise<AxiosResponse<any, any>> => {
    return axios.post('/graphe-actif',data);
}